import { CommonFrontOfficeCrumbs } from './breadcrumb';

export const ReleaseIdCardSearchPersonCrumbs = [
  ...CommonFrontOfficeCrumbs,
  {
    name: 'Ricerca Persona - Rilascio Carta Identità',
    path: '/sportello/rilascio-carta',
  },
];

export const ReleaseIdCardCrumbs = [
  ...ReleaseIdCardSearchPersonCrumbs,
  {
    name: 'Rilascio Carta Identità',
    path: '/sportello/rilascio-carta/rilascio',
  },
];
